import axios from 'axios';
const URL_API_CITA = process.env.VUE_APP_URL_API_CITA;

export class CitaApiService {
  
  getAllCitapreviaByOpuid(opuid) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_CITA}getAllCitapreviaByOpuid/${opuid}`;
    return axios
      .get(url,config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  // getAllCalenlabByOp(op) {
  //   let config = {
  //     headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
  //   };
  //   const url = `${URL_API_CALENLAB}getAllCalenlabByOpuid`;
  //   return axios
  //     .post(url, op,config)
  //     .then(function(response) {
  //       return response.data;
  //     })
  //     .catch(function(error) {
  //       if (error.response.status===401 || error.response.status===403){
  //         window.location.href = process.env.VUE_APP_PATH + '#/logout'
  //       }
  //       throw error;
  //     });
  // }

  deleteCitaPrevia(cita) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_CITA}deleteCitaPrevia`;
    return axios
      .delete(url, { data: cita }, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }

  addCitaPrevia(cita) {
    let config = {
      headers: {'Authorization': localStorage.getItem("token"), 'instalacion' : localStorage.getItem("instalacion")}
    };
    const url = `${URL_API_CITA}addCitaPrevia`;
    return axios
      .post(url, cita, config)
      .then(function(response) {
        return response.data;
      })
      .catch(function(error) {
        if (error.response.status===401 || error.response.status===403){
          window.location.href = process.env.VUE_APP_PATH + '#/logout'
        }
        throw error;
      });
  }
}